import * as types from '@/store/types'

export default {

	[types.GET_NSL]: state => {
        return state.nslList
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/nsl/getters.js